import React from "react";
import { Container, Typography } from "@mui/material";

const AdminHome = () => {
  return (
    <Container>
      <Typography variant="h2" paddingTop={"20px"}>
        Dashboard
      </Typography>
    </Container>
  );
};

export default AdminHome;
